import React, { useEffect, useState } from "react";
import Config from "../../config";
import BoatsTable from "./BoatsTable";
import Spinner from "../../components/Spinner";
import Error from "../../components/Error";
import Wrapper from "../../components/Wrapper";
import CustomButton from "../../components/CustomButton";
import Pagination from "../../components/Pagination";
import { TextField, Flex } from "@aws-amplify/ui-react";
import { ScrollView } from "@aws-amplify/ui-react";
import { useContx } from "../../AuthProvider";
import { MdSearch } from "react-icons/md";
import { IoCloseCircle } from "react-icons/io5";

const BoatsTablePage = () => {
  const { isUser, boats, getBoats, loading, error, pagination, totals } = useContx();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    isUser && getBoats(1);
    //eslint-disable-next-line
  }, []);

  const handleSearch = async () => {
    await getBoats(1, searchTerm);
  };

  const handleClear = () => {
    setSearchTerm("");
    getBoats(1, "");
  };

  let content = (
    <>
      <Flex alignItems="center" padding={10}>
        <CustomButton
          path={Config.routes.addLocation}
          state="Location"
          check={isUser}
        />
        <CustomButton
          margin="inherit"
          path={Config.routes.addBoat}
          state="Boat"
          check={isUser}
        />
      </Flex>
      <Flex direction="row" alignItems="center" gap="0.25rem">
        <div style={{ display: 'flex', position: "relative", width: "100%", maxWidth: "500px", paddingBottom: "2%", gap: "1%" }}>
          <TextField
            label="Search"
            placeholder="Search by name"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await getBoats(1, searchTerm);
              }
            }}
            width="100%"
          />
          {searchTerm && (
            <IoCloseCircle
              style={{
                cursor: "pointer",
                fontSize: "2.5rem",
                color: "gray",
                alignSelf: "end",
              }}
              onClick={handleClear}
            />
          )}
          <MdSearch
            style={{
              cursor: "pointer",
              fontSize: "2.5rem",
              color: "gray",
              alignSelf: "end",
            }}
            onClick={handleSearch}
          />
        </div>
      </Flex>
      <Wrapper>
        <br />
        <ScrollView width="100%">
          <BoatsTable boats={boats} />
          <Pagination
            fn={getBoats}
            cp={pagination?.boats?.currentPage}
            pp={pagination?.perPage}
            t={totals?.boats?.total}
            v={totals?.boats?.visited}
          />
        </ScrollView>
      </Wrapper>
    </>
  );

  if (loading) {
    content = <Spinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  return content;
};

export default BoatsTablePage;